import ImpactTdContents from './ImpactTdContents';
import ImpactThContents from './ImpactThContents';

export { ImpactThContents, ImpactTdContents };



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Impacts/index.js